export default "__VITE_ASSET__BXlUUm0L__"